/* ============================================================
   CART-001 (2026-08-25) - keep the cart count bubble accurate.

   The bubble ELEMENT is created by assets/shopflo-wiring.js, using the same
   markup the previously live theme had in its header:
   <span id="cart-count-bubble" class="flo-cart-icon-bubble">. Shopflo's bridge
   recognises that class and normally writes the number itself.

   This file is the FALLBACK. It paints the same element from /cart.js so the
   count is still right if the bridge has not initialised, if it stops managing
   the bubble in a future build, or on pages Shopflo does not touch. It never
   creates a second badge - it only writes the one wiring.js made.

   Palo Alto 9.2.0 ships NO count element at all: a query for
   #cart-count-bubble, [data-cart-count], [class*=cart-count] and
   [data-cart-items-qty] across the header returns an empty list. That is why
   the old SPEED-003 script silently did nothing after the update.

   /cart.js rather than any on-page number, because Shopflo owns the cart and
   its drawer changes the total without a page load.

   ROLLBACK: delete this file and its <script> line in layout/theme.liquid.
   ============================================================ */
(function () {
  'use strict';

  var BUBBLE = '.flo-cart-icon-bubble';
  var last = null;
  var timer = null;

  function paint(count) {
    if (count === null) return;
    last = count;
    document.querySelectorAll(BUBBLE).forEach(function (b) {
      b.textContent = count > 99 ? '99+' : String(count);
      b.classList.toggle('hidden', count <= 0);
    });
    document.querySelectorAll('.cart__toggle').forEach(function (t) {
      var sr = t.querySelector('.visually-hidden');
      if (sr) {
        sr.textContent = count > 0
          ? 'Open cart, ' + count + (count === 1 ? ' item' : ' items')
          : 'Open cart';
      }
    });
  }

  function read() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c.item_count; })
      .catch(function () { return null; });
  }

  function refresh() { return read().then(paint); }

  // Poll briefly after an add or remove and stop the moment the number moves,
  // rather than firing a fixed burst every time.
  function recheck() {
    if (timer) return;
    var tries = 0;
    var before = last;
    timer = setInterval(function () {
      tries++;
      read().then(function (c) {
        if (c !== null) paint(c);
        if ((c !== null && c !== before) || tries >= 6) {
          clearInterval(timer);
          timer = null;
        }
      });
    }, 250);
  }

  function start() {
    refresh();

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-add-to-cart], [data-add-to-cart-secondary], [name="add"], .btn-quick-buy, [data-remove-from-cart]')) {
        recheck();
      }
    }, { passive: true, capture: true });

    window.addEventListener('pplrAddToCartCompleted', recheck);
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    window.adornRefreshCartCount = refresh;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
